import { Configuration, LogLevel } from '@azure/msal-browser';

export const msalConfig: Configuration = {
    auth: {
        clientId: process.env.REACT_APP_ENTRA_CLIENT_ID!,
        authority: `https://login.microsoftonline.com/${process.env.REACT_APP_ENTRA_TENANT_ID}`,
        redirectUri: window.location.origin,
    },
    cache: {
        cacheLocation: 'sessionStorage',
    },
    system: {
        loggerOptions: {
            loggerCallback: (level, message, containsPii) => {
                if (containsPii) return;
                if (process.env.NODE_ENV === 'development') {
                    console.log(`[MSAL] ${message}`);
                }
            },
            logLevel: LogLevel.Warning,
        }
    }
};

export const loginRequest = {
    scopes: ['openid', 'profile', 'email']
};

// Used when calling the API — requests an access token scoped to your API
export const apiRequest = {
    scopes: [`api://${process.env.REACT_APP_ENTRA_CLIENT_ID}/access_as_user`]
};